import { request } from "graphql-request";
import { graphql } from "gql/gql";

import { BACKEND_DOMAIN } from "utils/constants";
import {
    buildRequestHeaders,
} from "utils/helpers";

const queryFn = (
    accessToken: string,
    carbonReductionMeasureUid: string
) =>
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: {
          carbonReductionMeasureUid
        },
        requestHeaders: buildRequestHeaders(accessToken),
    }).then(
        (data) =>
            data.measure
                .decarbonizationForecastChart as MeasureReportDecarbonizationForecastChart
    );

const query = graphql(`
    query measureReportDecarbonizationForecastChart(
        $carbonReductionMeasureUid: Uuid!

    ) {
        measure(
            carbonReductionMeasureUid: $carbonReductionMeasureUid
        ) {
            decarbonizationForecastChart {
                percentages {
                    currentMeasure
                    otherMeasureTypes
                    sameMeasureTypes
                }
                annualData {
                    calendarYear
                    carbonEmissionSavingsFromGrid
                    carbonReductionMeasureTypes {
                        carbonEmissionSavings
                        carbonReductionMeasureType
                        carbonReductionMeasureCategory
                    }
                    remainingCarbonEmissions
                }
            }
        }
    }
`);

export default queryFn;
